var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg9":""}},[_c('v-card',{staticClass:"pa-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }